import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

export function LinksSlider() {
    new Swiper(".links-slider", {
        loop: true,
        spaceBetween: 30,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1199: {
                slidesPerView: 4,
                spaceBetween: 30
            }
        },
        navigation: {
            nextEl: '.industry-slider-right',
            prevEl: '.industry-slider-left'
        }
    });
}

